<template>
    <div
        class="p-2 border bg-light"
    >
    {{ artist.name }}
        <b-row
            class="mb-4 small"
        >
            <b-col
            sm="7"
            class=""
            >             
                <p
                v-html="bioDates(artist)"
                />
            </b-col>
            <b-col
            sm="5"
            >
            <WikiImage 
                :imageSource="artist.wdItem"
                :commonsImage="artist.image"
            />
            </b-col>
        </b-row>  
        <b-row>
            <b-col
            sm="12"
            >
            <WikipediaArticles
                v-if="artist.wikipediaArticles"
                :articles="artist.wikipediaArticles"
                class="small py-2 border-top"
            />
            <div
                class="border-top"
            >
                <router-link
                tag="a"
                :to="`/artists/${artist.slug}`"
                >
                    weitere Informationen ...
                </router-link>
            </div>
            </b-col>
        </b-row>
    </div>

</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'
import WikiImage from '@/components/subparts/Wiki-image'
import WikipediaArticles from '@/components/subparts/Wikipedia-articles'

export default {
  name: 'artist-card',
  props: {
    artist: Object
  }, 
  components: {
    WikiImage,
    WikipediaArticles
  },
  data () {
    return {

}
  },
  methods: {
    ...mapActions({

    }),
    bioDates(currentArtist) {
      const options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }
      let placeOfBirth = currentArtist.placeOfBirthLabel
      let dateOfBirth = new Date(currentArtist.dateOfBirth.replace('+','')).toLocaleString('de-DE', options)
      let placeOfDeath = currentArtist.placeOfDeathLabel
      let dateOfDeath = new Date(currentArtist.dateOfDeath.replace('+','')).toLocaleString('de-DE', options)
      let description = `${currentArtist.description}`
      let bioDatesString = `
        ${description}<br>${placeOfBirth} ${dateOfBirth}<br>${placeOfDeath} ${dateOfDeath}
      `
      return bioDatesString
    }
  },
  computed: {
    ...mapGetters({

    }),
  },
  created () {
    
  }
}
</script>
<style scoped>
.chosen {
  background-color: #ccc;
  color: #666;
}
.lga-leaflet {
    column-count: 2;
    column-gap: 1.4rem;
  }
@media (max-width: 1400px) {
  .lga-leaflet {
    column-count: 1;
  }
}
.lga-sort-button {
  padding: .15rem .6rem;
}
</style>